export default "__VITE_ASSET__BbkibO6X__"